module.exports = __webpack_public_path__ + "img/close_hover.92581e1e.svg";